module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "line-desc-faq"
  }, [_c('div', {
    staticClass: "question-box"
  }, [_c('span', {
    staticClass: "main-index"
  }, [_vm._v("Q:")]), _vm._v(" "), _c('div', {
    staticClass: "question"
  }, [_vm._v(_vm._s(_vm.$t('title')))])]), _vm._v(" "), _c('div', {
    staticClass: "answer-box"
  }, [_c('span', {
    staticClass: "main-index"
  }, [_vm._v("A:")]), _vm._v(" "), _c('div', {
    staticClass: "answer"
  }, _vm._l((_vm.$t('content')), function(item, index) {
    return _c('p', {
      key: index
    }, [_vm._v(_vm._s(item))])
  }), 0)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0646f8fb!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/app/vpnPermissionDeniedFAQ/vpnPermissionDeniedFaq.vue
// module id = 1257
// module chunks = 1